import axios from "axios";
import store from "@/store/index";
import cleanParams from "./cleanParams";

const URL = window.location;
const CSRF_META = document.querySelector('meta[name="csrf-token"]');

const axiosNotify = axios.create({
	baseURL: `${URL.protocol}//${URL.hostname}/`,
});

axiosNotify.interceptors.request.use(
	async (config) => {
		const token = localStorage.getItem("auth_token");

		const data = {
			...config,
			headers: {
				...config.headers,
        Authorization: config.headers.Authorization || `Bearer ${token}`,
        'X-CSRF-TOKEN': CSRF_META?.getAttribute('content'),
			},
			params: cleanParams(config.params),
    }
    // console.debug('[request]', data)
		return data;
	},
	(error) => {
    console.warn('error');
		Promise.reject(error);
	}
);

axiosNotify.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (![200,202].includes(error.response.status)) {
			const responseMessage = error?.response?.data?.message;
			const responseError = error?.response?.data?.error;

			/**
			 * Reset b-alert message
			 * Bug Fix - CRA-915
			 */
			// store.commit("alert/error", "");
			/* end */

			if (responseMessage) {
				store.commit("alert/errorCmp", responseMessage);
			} else if (responseError) {
				store.commit("alert/errorCmp", responseError);
			} else {
				console.warn(error);
			}
		}
		return Promise.reject(error);
	}
);

export default axiosNotify;
